import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@env/environment';
import { enumEnvironmentName } from '@env/enumEnvironmentName';

if (environment.production) {
  enableProdMode();
}

declare let UET: any;
// moved this scripts out of index.html file for #9910
function loadExternalScripts(): void {
  if (environment.name === enumEnvironmentName.PROD) {
    /* Affiliate pixel */
    const script = document.createElement('script');
    script.src = 'https://www.dwin1.com/19038.js';
    script.defer = true;
    document.head.appendChild(script);
    /* End Affiliate pixel */

    /* Bing code */
    (function (w, d, t, r, u) {
      var f, n, i;
      (w[u] = w[u] || []),
        (f = function () {
          var o: any = { ti: '56260874' };

          (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
        }),
        (n = d.createElement(t)),
        (n.src = r),
        (n.async = 1),
        (n.onload = n.onreadystatechange =
          function () {
            var s = this.readyState;
            (s && s !== 'loaded' && s !== 'complete') || (f(), (n.onload = n.onreadystatechange = null));
          }),
        (i = d.getElementsByTagName(t)[0]),
        i.parentNode.insertBefore(n, i);
    })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
    /* End Bing code */

    /* Hotjar Tracking Code for https://app.eezyimport.com */
    (function (h: any, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 2324226, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    /* End Hotjar Tracking Code */
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    loadExternalScripts();

    if ('serviceWorker' in navigator && environment.production) {
      navigator.serviceWorker.register('ngsw-worker.js');
    }
  })
  .catch((err) => {
    loadExternalScripts();
    console.log(err);
  });
